const { domainMeta, getHireGoOrigin } = require('utils/domainMeta');

// Tenants with a dedicated hire cluster pin the wx release channel via Helm
// ConfigMap injection (see apps/hire/helm/tenants/aimbridge-na/values.yaml).
// REACT_APP_* vars are baked at build time by Webpack, so pod env overrides
// have no effect here. This map provides a hostname-derived browser-layer
// fallback for all custom-deploy tenants (both those with and without a
// dedicated hire cluster, including UPS which runs on shared infra).
const TENANT_WX_RELEASE_CHANNELS = {
  aimbridge: 'aimbridge',
  ups: 'ups',
};

const REACT_APP_MONOLITH_BASE_URL = domainMeta.monolithOrigin;
const REACT_APP_GLOBAL_API_BASE_URL = `${domainMeta.monolithOrigin}/api_self_serve/v1`;
const REACT_APP_GLOBAL_API_BASE_URL_V2 = `${domainMeta.monolithOrigin}/api_self_serve/v2`;
const REACT_APP_LANDING_PAGE_URL = `${domainMeta.monolithOrigin}/users/sign_in`;
const REACT_APP_SIGN_OUT_REDIRECT_URL = `${domainMeta.monolithOrigin}/users/sign_in`;
module.exports = {
  REACT_APP_MONOLITH_BASE_URL,
  REACT_APP_GLOBAL_API_BASE_URL,
  REACT_APP_GLOBAL_API_BASE_URL_V2,
  REACT_APP_LANDING_PAGE_URL,
  REACT_APP_SIGN_OUT_REDIRECT_URL,
  REACT_APP_WX_COPILOT_VERSION: 'v3',
  REACT_APP_WX_COPILOT_RELEASE_CHANNEL:
    process.env.REACT_APP_WX_COPILOT_RELEASE_CHANNEL ||
    TENANT_WX_RELEASE_CHANNELS[domainMeta.tenant] ||
    (domainMeta.environment === 'prod' ? 'stable' : 'main'),
  get REACT_APP_WX_COPILOT_URL() {
    return (
      process.env.REACT_APP_WX_COPILOT_URL ||
      `https://ftn-shared-components.fountain.com/wx-copilot/${this.REACT_APP_WX_COPILOT_VERSION}/release/${this.REACT_APP_WX_COPILOT_RELEASE_CHANNEL}/wx-copilot.umd.js`
    );
  },
  REACT_APP_WX_NAVBAR_VERSION: 'v3',
  REACT_APP_WX_NAVBAR_RELEASE_CHANNEL:
    process.env.REACT_APP_WX_NAVBAR_RELEASE_CHANNEL ||
    TENANT_WX_RELEASE_CHANNELS[domainMeta.tenant] ||
    (domainMeta.environment === 'prod' ? 'stable' : 'main'),
  get REACT_APP_WX_NAVBAR_URL() {
    return (
      process.env.REACT_APP_WX_NAVBAR_URL ||
      `https://ftn-shared-components.fountain.com/wx-navbar/${this.REACT_APP_WX_NAVBAR_VERSION}/release/${this.REACT_APP_WX_NAVBAR_RELEASE_CHANNEL}/wx-navbar.umd.js`
    );
  },
  REACT_APP_WX_LAUNCH_DARKLY_CLIENT_SIDE_ID:
    process.env.REACT_APP_WX_LAUNCH_DARKLY_CLIENT_SIDE_ID ||
    domainMeta.launchDarklyClientSideId,
  NODE_ENV: process.env.NODE_ENV,
  REACT_APP_CLEARBIT_API_BASE_URL: process.env.REACT_APP_CLEARBIT_API_BASE_URL,
  REACT_APP_FAKER_SEED: process.env.REACT_APP_FAKER_SEED,
  REACT_APP_HIRE_GO_BASE_URL:
    process.env.REACT_APP_HIRE_GO_BASE_URL ||
    getHireGoOrigin(domainMeta.environment),
  REACT_APP_POSTHOG_API_KEY: process.env.REACT_APP_POSTHOG_API_KEY,
  REACT_APP_POSTHOG_HOST: process.env.REACT_APP_POSTHOG_HOST,
  REACT_APP_POSTHOG_UI_HOST: process.env.REACT_APP_POSTHOG_UI_HOST,
  REACT_APP_POSTHOG_DEBUG: process.env.REACT_APP_POSTHOG_DEBUG,
};
